export default __webpack_public_path__ + "static/media/paperpaw.5cf3d8d5.png";